// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkflowEdge_edgePath__QWV9I {
  stroke: #888;
  stroke-width: 2px;
  fill: none;
}

.WorkflowEdge_edgeButton__2taPk {
  fill: #fff;
  stroke: #007aff;
  stroke-width: 2px;
  cursor: pointer;
  transition: fill 0.2s;
}

.WorkflowEdge_edgeButton__2taPk:hover {
  fill: #e6f0ff;
}

.WorkflowEdge_edgeButtonText__xqGbz {
  font-size: 18px;
  fill: #007aff;
  pointer-events: none;
  font-weight: bold;
}

.WorkflowEdge_edgePlus__R3LeQ {
  stroke: #007aff;
  stroke-width: 2;
  stroke-linecap: round;
  pointer-events: none;
}

.WorkflowEdge_selectedEdge__7BMIz {
  stroke: #ff3366 !important;
  stroke-width: 3px !important;
  filter: drop-shadow(0 0 2px rgba(255, 51, 102, 0.5));
} 
/* ── 다크 테마 보정 (html.dark) ── */
.dark .WorkflowEdge_edgePath__QWV9I {
  stroke: #9a9a9a;
}
.dark .WorkflowEdge_edgeButton__2taPk {
  fill: #252526;
  stroke: #3794ff;
}
.dark .WorkflowEdge_edgeButton__2taPk:hover {
  fill: #094771;
}
.dark .WorkflowEdge_edgeButtonText__xqGbz {
  fill: #3794ff;
}

.dark .WorkflowEdge_edgePlus__R3LeQ {
  stroke: #60a5fa;
}

/* ── 엣지 + 버튼: 드롭 영역/강조 */
/* + 는 평소에는 감춘다 — 선이 많은 캔버스에서 + 가 줄줄이 떠 노드와 선을 가렸다(현장 2026-10-12).
   연결선에 마우스를 올렸을 때, 그 선을 골랐을 때, 툴박스에서 끌고 있을 때(놓을 자리 안내)만 보인다.
   감춘 동안에도 자리는 눌린다(투명일 뿐) — 선 가운데에 마우스가 가면 선의 :hover 로 바로 나타난다 */
.WorkflowEdge_edgeButtonGroup__iwkiR { cursor: pointer; opacity: 0; transition: opacity 0.12s ease; }
.react-flow__edge:hover .WorkflowEdge_edgeButtonGroup__iwkiR,
.react-flow__edge.selected .WorkflowEdge_edgeButtonGroup__iwkiR,
.WorkflowEdge_edgeButtonGroup__iwkiR.WorkflowEdge_edgeButtonDropTarget__iew-4 { opacity: 1; }
.WorkflowEdge_edgeHitArea__WkO\\+Z { fill: transparent; stroke: none; }
.WorkflowEdge_edgeButton__2taPk, .WorkflowEdge_edgePlus__R3LeQ { transition: all 0.12s ease; }
/* 툴박스에서 드래그 중: 모든 + 를 눈에 띄게 (점선 링) */
.WorkflowEdge_edgeButtonDropTarget__iew-4 .WorkflowEdge_edgeButton__2taPk {
  stroke-dasharray: 3 2;
  stroke-width: 2px;
  fill: #eaf2ff;
}
/* 커서가 반경 안: 활성(놓으면 여기에 삽입) */
.WorkflowEdge_edgeButtonDropActive__5G5Fb .WorkflowEdge_edgeButton__2taPk {
  fill: #007aff;
  stroke: #007aff;
  stroke-dasharray: none;
}
.WorkflowEdge_edgeButtonDropActive__5G5Fb .WorkflowEdge_edgePlus__R3LeQ { stroke: #fff; stroke-width: 3; }
.WorkflowEdge_edgeDropRing__S6wOo {
  fill: rgba(0, 122, 255, 0.12);
  stroke: #007aff;
  stroke-width: 1.5;
  animation: WorkflowEdge_edgeDropPulse__q7uPp 0.9s ease-in-out infinite;
}
@keyframes WorkflowEdge_edgeDropPulse__q7uPp {
  0%, 100% { r: 20; opacity: 0.9; }
  50% { r: 26; opacity: 0.4; }
}
.dark .WorkflowEdge_edgeButtonDropTarget__iew-4 .WorkflowEdge_edgeButton__2taPk { fill: #1e3a5f; }
.dark .WorkflowEdge_edgeButtonDropActive__5G5Fb .WorkflowEdge_edgeButton__2taPk { fill: #3794ff; stroke: #3794ff; }

/* 예외 흐름(데이터처리 실패 시 가는 길)의 + 는 붉게 — 정상 흐름의 파란 + 와 구분된다 (utils/errorFlow) */
.WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgeButton__2taPk { stroke: #dc2626; }
.WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgeButton__2taPk:hover { fill: #fee2e2; }
.WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgePlus__R3LeQ { stroke: #dc2626; }
.dark .WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgeButton__2taPk { stroke: #f87171; }
.dark .WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgeButton__2taPk:hover { fill: #7f1d1d; }
.dark .WorkflowEdge_edgeButtonErrorGroup__ZBq6x .WorkflowEdge_edgePlus__R3LeQ { stroke: #f87171; }
`, "",{"version":3,"sources":["webpack://./src/components/workflow/edges/WorkflowEdge.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,oDAAoD;AACtD;AACA,+BAA+B;AAC/B;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;;gEAEgE;AAChE,uCAAmB,eAAe,EAAE,UAAU,EAAE,8BAA8B,EAAE;AAChF;;gFAEwC,UAAU,EAAE;AACpD,oCAAe,iBAAiB,EAAE,YAAY,EAAE;AAChD,iEAAyB,0BAA0B,EAAE;AACrD,qCAAqC;AACrC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA,0EAAkC,YAAY,EAAE,eAAe,EAAE;AACjE;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,sEAAkD;AACpD;AACA;EACE,WAAW,KAAK,EAAE,YAAY,EAAE;EAChC,MAAM,KAAK,EAAE,YAAY,EAAE;AAC7B;AACA,kFAAmD,aAAa,EAAE;AAClE,kFAAmD,aAAa,EAAE,eAAe,EAAE;;AAEnF,0EAA0E;AAC1E,4EAAoC,eAAe,EAAE;AACrD,kFAA0C,aAAa,EAAE;AACzD,0EAAkC,eAAe,EAAE;AACnD,kFAAmD,eAAe,EAAE;AACpE,wFAAyD,aAAa,EAAE;AACxE,gFAAiD,eAAe,EAAE","sourcesContent":[".edgePath {\r\n  stroke: #888;\r\n  stroke-width: 2px;\r\n  fill: none;\r\n}\r\n\r\n.edgeButton {\r\n  fill: #fff;\r\n  stroke: #007aff;\r\n  stroke-width: 2px;\r\n  cursor: pointer;\r\n  transition: fill 0.2s;\r\n}\r\n\r\n.edgeButton:hover {\r\n  fill: #e6f0ff;\r\n}\r\n\r\n.edgeButtonText {\r\n  font-size: 18px;\r\n  fill: #007aff;\r\n  pointer-events: none;\r\n  font-weight: bold;\r\n}\r\n\r\n.edgePlus {\r\n  stroke: #007aff;\r\n  stroke-width: 2;\r\n  stroke-linecap: round;\r\n  pointer-events: none;\r\n}\r\n\r\n.selectedEdge {\r\n  stroke: #ff3366 !important;\r\n  stroke-width: 3px !important;\r\n  filter: drop-shadow(0 0 2px rgba(255, 51, 102, 0.5));\r\n} \r\n/* ── 다크 테마 보정 (html.dark) ── */\r\n:global(.dark) .edgePath {\r\n  stroke: #9a9a9a;\r\n}\r\n:global(.dark) .edgeButton {\r\n  fill: #252526;\r\n  stroke: #3794ff;\r\n}\r\n:global(.dark) .edgeButton:hover {\r\n  fill: #094771;\r\n}\r\n:global(.dark) .edgeButtonText {\r\n  fill: #3794ff;\r\n}\r\n\r\n:global(.dark) .edgePlus {\r\n  stroke: #60a5fa;\r\n}\r\n\r\n/* ── 엣지 + 버튼: 드롭 영역/강조 */\r\n/* + 는 평소에는 감춘다 — 선이 많은 캔버스에서 + 가 줄줄이 떠 노드와 선을 가렸다(현장 2026-10-12).\r\n   연결선에 마우스를 올렸을 때, 그 선을 골랐을 때, 툴박스에서 끌고 있을 때(놓을 자리 안내)만 보인다.\r\n   감춘 동안에도 자리는 눌린다(투명일 뿐) — 선 가운데에 마우스가 가면 선의 :hover 로 바로 나타난다 */\r\n.edgeButtonGroup { cursor: pointer; opacity: 0; transition: opacity 0.12s ease; }\r\n:global(.react-flow__edge:hover) .edgeButtonGroup,\r\n:global(.react-flow__edge.selected) .edgeButtonGroup,\r\n.edgeButtonGroup.edgeButtonDropTarget { opacity: 1; }\r\n.edgeHitArea { fill: transparent; stroke: none; }\r\n.edgeButton, .edgePlus { transition: all 0.12s ease; }\r\n/* 툴박스에서 드래그 중: 모든 + 를 눈에 띄게 (점선 링) */\r\n.edgeButtonDropTarget .edgeButton {\r\n  stroke-dasharray: 3 2;\r\n  stroke-width: 2px;\r\n  fill: #eaf2ff;\r\n}\r\n/* 커서가 반경 안: 활성(놓으면 여기에 삽입) */\r\n.edgeButtonDropActive .edgeButton {\r\n  fill: #007aff;\r\n  stroke: #007aff;\r\n  stroke-dasharray: none;\r\n}\r\n.edgeButtonDropActive .edgePlus { stroke: #fff; stroke-width: 3; }\r\n.edgeDropRing {\r\n  fill: rgba(0, 122, 255, 0.12);\r\n  stroke: #007aff;\r\n  stroke-width: 1.5;\r\n  animation: edgeDropPulse 0.9s ease-in-out infinite;\r\n}\r\n@keyframes edgeDropPulse {\r\n  0%, 100% { r: 20; opacity: 0.9; }\r\n  50% { r: 26; opacity: 0.4; }\r\n}\r\n:global(.dark) .edgeButtonDropTarget .edgeButton { fill: #1e3a5f; }\r\n:global(.dark) .edgeButtonDropActive .edgeButton { fill: #3794ff; stroke: #3794ff; }\r\n\r\n/* 예외 흐름(데이터처리 실패 시 가는 길)의 + 는 붉게 — 정상 흐름의 파란 + 와 구분된다 (utils/errorFlow) */\r\n.edgeButtonErrorGroup .edgeButton { stroke: #dc2626; }\r\n.edgeButtonErrorGroup .edgeButton:hover { fill: #fee2e2; }\r\n.edgeButtonErrorGroup .edgePlus { stroke: #dc2626; }\r\n:global(.dark) .edgeButtonErrorGroup .edgeButton { stroke: #f87171; }\r\n:global(.dark) .edgeButtonErrorGroup .edgeButton:hover { fill: #7f1d1d; }\r\n:global(.dark) .edgeButtonErrorGroup .edgePlus { stroke: #f87171; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edgePath": `WorkflowEdge_edgePath__QWV9I`,
	"edgeButton": `WorkflowEdge_edgeButton__2taPk`,
	"edgeButtonText": `WorkflowEdge_edgeButtonText__xqGbz`,
	"edgePlus": `WorkflowEdge_edgePlus__R3LeQ`,
	"selectedEdge": `WorkflowEdge_selectedEdge__7BMIz`,
	"edgeButtonGroup": `WorkflowEdge_edgeButtonGroup__iwkiR`,
	"edgeButtonDropTarget": `WorkflowEdge_edgeButtonDropTarget__iew-4`,
	"edgeHitArea": `WorkflowEdge_edgeHitArea__WkO+Z`,
	"edgeButtonDropActive": `WorkflowEdge_edgeButtonDropActive__5G5Fb`,
	"edgeDropRing": `WorkflowEdge_edgeDropRing__S6wOo`,
	"edgeDropPulse": `WorkflowEdge_edgeDropPulse__q7uPp`,
	"edgeButtonErrorGroup": `WorkflowEdge_edgeButtonErrorGroup__ZBq6x`
};
export default ___CSS_LOADER_EXPORT___;
